module.exports = __webpack_public_path__ + "static/Megrim-e43a0f17594beb98a1f373738814ab9e.ttf";